import React from "react";
import { Alert, Autocomplete, Box, TextField, Typography } from "@mui/material";

export function formatClientLabel(client) {
  if (!client) return "";
  const name = client.client_name?.trim() || "Unnamed client";
  const id = client.client_id ?? "";
  return `${name} (Client ID: ${id})`;
}

export default function ClientSelectAutocomplete({
  clients,
  selectedClient,
  onChange,
  disabled = false,
}) {
  return (
    <>
      <Autocomplete
        options={clients}
        disabled={disabled}
        getOptionLabel={formatClientLabel}
        isOptionEqualToValue={(a, b) => a?.client_id === b?.client_id}
        value={selectedClient}
        onChange={onChange}
        renderOption={(props, option) => (
          <li {...props} key={option.client_id}>
            <Box>
              <Typography variant="body1">
                {option.client_name || "Unnamed client"}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Client ID: {option.client_id}
              </Typography>
            </Box>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Client (name and ID)"
            placeholder="Search by client name or ID"
            required
            margin="normal"
            fullWidth
          />
        )}
        filterOptions={(options, { inputValue }) => {
          const q = inputValue.trim().toLowerCase();
          if (!q) return options;
          return options.filter((o) => {
            const name = String(o.client_name || "").toLowerCase();
            const id = String(o.client_id ?? "");
            return name.includes(q) || id.includes(q);
          });
        }}
      />
      {selectedClient && (
        <Alert severity="info" sx={{ mt: 1 }}>
          Selected client: <strong>{selectedClient.client_name}</strong> — Client
          ID: <strong>{selectedClient.client_id}</strong>
        </Alert>
      )}
    </>
  );
}
